import { createRealGetRequest } from ".";
import { paths } from "../navmenu.types";

export const realGetUserMenuList = createRealGetRequest<
  paths["/exp/v1/dna/header/getUserMenuList"]
>("/header/getUserMenuList");
